export default __webpack_public_path__ + "static/media/al.426b2603.png";